<template>
  <div class="col-md-6 col-sm-6 col-xs-6">
    <div class="row col-12 justify-end q-mt-xl q-gutter-sm">
      <div class="col-md-2">
        <SelectComponentGrupos
          @emitirGrupo="receberDadosGrupoFiltro"
          :subGrupoCategoriaUuid="subGrupoFiltro?.categoria_uuid"
          :label="'Grupo'"
          :rounded="true"
        />
      </div>
      <div class="col-md-2">
        <SelectComponentSubGrupos
          @emitirSubGrupo="receberDadosSubGrupoFiltro"
          :categoriaUuid="grupoFiltro?.uuid"
          :label="'Sub Grupo'"
          :rounded="true"
        />
      </div>
      <div class="col-md-2">
        <q-input
          rounded
          outlined
          dense
          v-model="patrimonio"
          type="text"
          placeholder="Patrimônio"
        >
        </q-input>
      </div>
      <div class="col-md-2">
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filter"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
    </div>
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      class="q-mt-sm"
      :rows="listaFerramentas"
      dense
      :columns="columns"
      :loading="disable"
      :rows-per-page-options="[0]"
      hide-bottom
      selection="single"
      row-key="uuid"
      v-model:selected="selected"
      no-data-label
    >
      <template #body-cell-nome="props">
        <q-td>
          {{ props.row.nome }}
        </q-td>
      </template>
      <template #body-cell-descricao="props">
        <q-td>
          {{ props.row.descricao }}
        </q-td>
      </template>
      <template #body-cell-detalhes="props">
        <q-td>
          <router-link
            class="row col-12 justify-center"
            :to="{
              name: 'movimentarStatusFerramentaDetalhes',
              params: { id: props.row.uuid },
            }"
          >
            <q-btn class="q-mr-md" color="blue-6" round size="sm" icon="add" />
          </router-link>
        </q-td>
      </template>
      <template #body-cell-status="props">
        <q-td>
          <div
            :style="
              props.row.status == 'disponivel'
                ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                : props.row.status == 'manutencao_garantia'
                ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                : props.row.status == 'uso'
                ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                : props.row.status == 'manutencao'
                ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                : props.row.status == 'em_transito'
                ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                : props.row.status == 'removida'
                ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                : props.row.status == 'retorno_em_garantia'
                ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                : props.row.status == 'desmobilizada'
                ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                : props.row.status == 'reativacao'
                ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                : props.row.status == 'descartada'
                ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                : props.row.status == 'sucata'
                ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                : props.row.status == 'furto'
                ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                : props.row.status == 'aguardando_reparo'
                ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                : props.row.status == 'calibracao'
                ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                : props.row.status == 'aguardando_calibracao'
                ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                : ''
            "
            class="row col-12 no-wrap align items-center nao-quebrar-linha"
          >
            <span
              v-if="props.row.status == 'disponivel'"
              class="elipse q-mr-sm bg-positive"
            ></span>
            <span
              v-if="props.row.status == 'uso'"
              class="elipse q-mr-sm bg-warning"
            ></span>
            <span
              v-if="props.row.status == 'manutencao_garantia'"
              class="elipse q-mr-sm"
              style="background: #424242"
            ></span>
            <span
              v-if="props.row.status == 'manutencao'"
              class="elipse q-mr-sm bg-red"
            ></span>
            <span
              v-if="props.row.status == 'em_transito'"
              class="elipse q-mr-sm"
              style="background: #2d3e6e"
            ></span>
            <span
              v-if="props.row.status == 'removida'"
              class="elipse q-mr-sm"
              style="background: #383737"
            ></span>
            <span
              v-if="props.row.status == 'retorno_em_garantia'"
              class="elipse q-mr-sm"
              style="background: #383737"
            ></span>
            <span
              v-if="props.row.status == 'calibracao'"
              class="elipse q-mr-sm"
              style="background: #383737"
            ></span>
            <span
              v-if="props.row.status == 'desmobilizada'"
              class="elipse q-mr-sm"
              style="background: #fa9726"
            ></span>
            <span
              v-if="props.row.status == 'reativacao'"
              class="elipse q-mr-sm"
              style="background: #473fe8"
            ></span>
            <span
              v-if="props.row.status == 'descartada'"
              class="elipse q-mr-sm"
              style="background: #b0cde8"
            ></span>
            <span
              v-if="props.row.status == 'sucata'"
              class="elipse q-mr-sm"
              style="background: #736d6a"
            ></span>
            <span
              v-if="props.row.status == 'furto'"
              class="elipse q-mr-sm"
              style="background: #6b1215"
            ></span>
            <span
              v-if="props.row.status == 'aguardando_reparo'"
              class="elipse q-mr-sm"
              style="background: #fa9726"
            ></span>
            <span
              v-if="props.row.status == 'aguardando_calibracao'"
              class="elipse q-mr-sm"
              style="background: #11009e"
            ></span>
            <div
              v-if="props.row.status == 'disponivel'"
              style="width: fit-content; background: #e8ffec"
              class="text-brand-5 text-bold"
            >
              {{ "Disponivel" }}
            </div>
            <div
              v-if="props.row.status == 'uso'"
              style="width: fit-content; background: #fefed1"
              class="text-brand-5 text-bold"
            >
              {{ "Em Uso" }}
            </div>
            <div
              v-if="props.row.status == 'manutencao_garantia'"
              style="width: fit-content"
              class="text-brand-5 text-bold"
            >
              {{ "Manutenção Garantia" }}
            </div>
            <div
              v-if="props.row.status == 'manutencao'"
              style="width: fit-content"
              class="text-red text-bold"
            >
              {{ "Manutenção" }}
            </div>
            <div
              v-if="props.row.status == 'em_transito'"
              style="width: fit-content; color: #192957"
              class="text-bold"
            >
              {{ "Em Trânsito" }}
            </div>
            <div
              v-if="props.row.status == 'removida'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Removida" }}
            </div>
            <div
              v-if="props.row.status == 'retorno_em_garantia'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Retorno Em Garantia" }}
            </div>
            <div
              v-if="props.row.status == 'desmobilizada'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Desmobilizada" }}
            </div>
            <div
              v-if="props.row.status == 'reativacao'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Reativação" }}
            </div>
            <div
              v-if="props.row.status == 'descartada'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Descartada" }}
            </div>
            <div
              v-if="props.row.status == 'sucata'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Sucata" }}
            </div>
            <div
              v-if="props.row.status == 'furto'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Furto" }}
            </div>
            <div
              v-if="props.row.status == 'aguardando_reparo'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Aguardando Reparo" }}
            </div>
            <div
              v-if="props.row.status == 'calibracao'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Calibração" }}
            </div>
            <div
              v-if="props.row.status == 'aguardando_calibracao'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Aguardando Calibração" }}
            </div>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="q-mt-md row justify-start">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { watchDebounced } from "@vueuse/core";
import SelectComponentGrupos from "./SelectComponentGrupos.vue";
import SelectComponentSubGrupos from "./SelectComponentSubGrupos.vue";

export default {
  name: "SelectComponentResponsaveis",
  props: ["atualizar", "resetar"],
  components: { SelectComponentGrupos, SelectComponentSubGrupos },
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const unidade = ref({
      id: "",
      nome: "",
    });
    const filter = ref("");
    const disable = ref(true);
    const selected = ref([]);
    const listaUnidades = ref([]);
    const listaFerramentas = ref([]);
    const selecionaImagem = ref(false);
    const grupoFiltro = ref({});
    const subGrupoFiltro = ref({});
    const patrimonio = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });

    const columns = [
      {
        name: "nome",
        label: "Código",
        field: "nome",
        align: "left",
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
      },
      {
        name: "patrimonio",
        label: "Patrimonio",
        field: (row) => row.patrimonio,
        align: "left",
      },
      {
        name: "status",
        label: "Status Atual",
        field: "status",
        align: "left",
        sortable: true,
      },
      {
        name: "detalhes",
        label: "Detalhes",
        field: "detalhes",
        align: "center",
        sortable: true,
      },
    ];

    let listarFerramentas = async (page = 1, rowsNumber = 100) => {
      disable.value = true;
      try {
        let resposta = await store.dispatch("fer/listarFerramentas", {
          unidadeId: store.state.org.unidadeData.id,
          perPage: rowsNumber,
          page: page,
          filtro: filter.value,
          categoria: grupoFiltro.value.nome,
          grupo: subGrupoFiltro.value.nome,
          patrimonio: patrimonio.value,
        });

        listaFerramentas.value = resposta.resposta.data.result.data;
        pagination.value.page = resposta.resposta.data.result.current_page;
        pagination.value.rowsPerPage = resposta.resposta.data.result.per_page;
        pagination.value.rowsNumber = resposta.resposta.data.result.total;
        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    const receberDadosGrupoFiltro = async (value) => {
      if (value === "") {
        subGrupoFiltro.value = {
          uuid: "",
          nome: "",
          categoria_uuid: "",
          descricao: "",
        };
        grupoFiltro.value = { descricao: "", uuid: "", nome: "" };
        return;
      }
      grupoFiltro.value = value;
    };

    const receberDadosSubGrupoFiltro = async (value) => {
      if (value === "") {
        subGrupoFiltro.value = {
          uuid: "",
          nome: "",
          categoria_uuid: "",
          descricao: "",
        };
        return;
      }
      subGrupoFiltro.value = value;
    };

    onMounted(() => {
      listarFerramentas();
    });

    watch(
      () => selected.value,
      () => {
        emit("selectValue", selected);
      }
    );

    watch(
      () => filter.value,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => props.resetar,
      () => {
        selected.value = [];
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentas(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watchDebounced(
      [
        () => patrimonio.value,
        () => subGrupoFiltro.value,
        () => grupoFiltro.value,
        () => filter.value,
      ],
      () => {
        listarFerramentas();
      },
      { debounce: 400 }
    );

    const detalhes = async (value) => {
      router.push({
        name: "movimentarStatusFerramentaDetalhes",
        params: { id: value },
      });
    };

    return {
      unidade,
      selecionaImagem,
      listaFerramentas,
      listaUnidades,
      columns,
      selected,
      grupoFiltro,
      subGrupoFiltro,
      disable,
      filter,
      receberDadosGrupoFiltro,
      receberDadosSubGrupoFiltro,
      detalhes,
      pagination,
      patrimonio,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.nao-quebrar-linha {
  display: flex;
  flex-wrap: nowrap !important;
}
tbody tr td {
  white-space: pre-wrap;
  max-width: 150px;
}
</style>
